import { useEffect, useState } from "react";
import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useCommonDataFindAllQuery, useParameterGroundStorageCreateMutation, useParameterGroundStorageDeleteMutation, useParameterGroundStorageFindAllQuery, useParameterGroundStorageUpdateMutation } from "store";
import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "Components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import Switch from "react-switch";
import waterStorageSvg from "../../../assets/images/svg/waterStorage.svg"
import DeleteModal from "Components/Common/DeleteModal";
import Flatpickr from "react-flatpickr";

const GroundStorage = ({ boreholeId }: any) => {
  const { id } = useParams();
  const [isLoading, setLoading] = useState(true)

  const { data, error, isFetching } = useParameterGroundStorageFindAllQuery(`?groundwater_id=${id}&groundwater_borehole_parameter_id=${boreholeId}`);
  const [groundStorageCreate, groundStorageCreateResult] = useParameterGroundStorageCreateMutation();
  const [groundStorageUpdate, groundStorageUpdateResult] = useParameterGroundStorageUpdateMutation();
  const [groundStorageDelete, groundStorageDeleteResult] = useParameterGroundStorageDeleteMutation();

  const [waterbearing, setWaterbearing] = useState<any>();

  const [is_newCreated, setIs_newCreated] = useState<boolean>(false);
  const [measurementList, setMeasurementList] = useState<any>();
  const [meaCount, setMeaCount] = useState<any>();

  const {
    data: rankData,
    error: rankDataError,
    isFetching: isRankDataFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmd_groundwater_rank`);

  useEffect(() => {
    if (waterbearing === undefined) {
      setLoading(true);
    } else {
      setLoading(false);
    }
    if (data?.data.length !== 0) {
      setMeasurementList(data?.data);
      setMeaCount(measurementList?.length);
    } else {
      setMeasurementList(null)
      setMeaCount(null)
      setLoading(true);
      // setWaterbearing(null)
    }
    if (is_newCreated) {
      setLoading(false);
    }
  }, [waterbearing, id, data?.data, boreholeId])


  const validation: any = useFormik({
    enableReinitialize: true,

    initialValues: {
      id: waterbearing?.id,
      groundwater_id: waterbearing?.groundwater_id,
      groundwater_code: waterbearing?.groundwater_code,
      measure_date: waterbearing?.measure_date,
      groundwater_borehole_parameter_code: waterbearing?.groundwater_borehole_parameter_code,
      waterusage_resource_borehole_code: waterbearing?.waterusage_resource_borehole_code,
      hydrogeological_borehole_depth: waterbearing?.hydrogeological_borehole_depth,
      water_resource: waterbearing?.water_resource,
      cmd_groundwater_rank: waterbearing?.cmd_groundwater_rank,
      water_level_decrease: waterbearing?.water_level_decrease,
      waterbearing_thickness: waterbearing?.waterbearing_thickness,
      waterbearing_location: waterbearing?.waterbearing_location,
      water_resource_year: waterbearing?.water_resource_year,
    },
    validationSchema: Yup.object({
      groundwater_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      measure_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
      waterusage_resource_borehole_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      hydrogeological_borehole_depth: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"), water_resource: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      cmd_groundwater_rank: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      groundwater_borehole_parameter_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("утга оруулна уу !"),
      water_level_decrease: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      waterbearing_thickness: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      waterbearing_location: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      water_resource_year: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (waterbearing !== null) {
        const updateList = {
          id: waterbearing?.id,
          groundwater_id: waterbearing?.groundwater_id,
          groundwater_code: values.groundwater_code,
          measure_date: values.measure_date,
          groundwater_borehole_parameter_code: values.groundwater_borehole_parameter_code,
          waterusage_resource_borehole_code: values.waterusage_resource_borehole_code,
          hydrogeological_borehole_depth: values.hydrogeological_borehole_depth,
          water_resource: values.water_resource,
          cmd_groundwater_rank: values.cmd_groundwater_rank,
          water_level_decrease: values.water_level_decrease,
          waterbearing_thickness: values.waterbearing_thickness,
          waterbearing_location: values.waterbearing_location,
          water_resource_year: values.water_resource_year,
        }
        groundStorageUpdate(updateList);
      } else {
        const newList = {
          groundwater_id: id,
          groundwater_code: values["groundwater_code"],
          measure_date: values["measure_date"],
          groundwater_borehole_parameter_id: boreholeId,
          groundwater_borehole_parameter_code: values["groundwater_borehole_parameter_code"],
          waterusage_resource_borehole_code: values["waterusage_resource_borehole_code"],
          hydrogeological_borehole_depth: values["hydrogeological_borehole_depth"],
          water_resource: values["water_resource"],
          cmd_groundwater_rank: values["cmd_groundwater_rank"],
          water_level_decrease: values["water_level_decrease"],
          waterbearing_thickness: values["waterbearing_thickness"],
          waterbearing_location: values["waterbearing_location"],
          water_resource_year: values["water_resource_year"],
        };
        groundStorageCreate(newList)
      }
      // validation.resetForm();
    },
  });

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = () => {
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (waterbearing) {
      groundStorageDelete(waterbearing.id);
      setDeleteModal(false);
    }
    setWaterbearing(null);
    setIs_newCreated(true)
  };

  return (

    <>
      <Row>
        <Col lg={12}>
          <div className="d-flex align-items-center mb-3">
            <img src={waterStorageSvg} alt="" height="50" />
            <div className="flex-grow-1 ms-3">
              <h5 className="fw-semibold">Мэдээлэл</h5>
              <ul className="list-unstyled hstack gap-2 mb-0">
                <li>
                  <i className="mdi mdi-table-row-height"></i>{" "}
                  <span className="text-muted fw-semibold">
                    Нийт: {meaCount}
                  </span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              disabled={is_newCreated === true ? true : false}
              className="btn btn-success  btn-label me-3"
              onClick={() => {
                validation.resetForm();
                setWaterbearing(null);
                setIs_newCreated(true);
              }}
            >
              <i className="mdi mdi-file-plus-outline label-icon"></i>
              Шинээр нэмэх
            </button>
            {
              is_newCreated === false && waterbearing !== null ?
                <button
                  type="button"
                  onClick={(event: any) => {
                    event.preventDefault();
                    onClickDelete();
                  }}
                  className="btn btn-danger  btn-label"
                >
                  <i className="mdi mdi-delete-empty-outline label-icon"></i> Устгах
                </button>
                : ''
            }
          </div>
        </Col>
      </Row>
      <Row>
        <DeleteModal
          deleteName={waterbearing?.waterbearing_location}
          show={deleteModal}
          onDeleteClick={handleDeletejob}
          onCloseClick={() => setDeleteModal(false)}
        />
        <Col lg={3}>
          <ul className="verti-timeline list-unstyled">
            {measurementList?.map((item, index) => (
              <li className="event-list active">
                <div className="event-timeline-dot">
                  <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="flex-shrink-0 d-flex">
                  <div key={index} className="d-flex mb-3">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item?.created_at.split("T")[0]}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <Link
                          to="#"
                          className="cursor fw-semibold"
                          onClick={() => {
                            setIs_newCreated(false)
                            setWaterbearing(item)
                          }}
                        >
                          {item?.measure_date}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
        <Col lg={9}>
          {
            isLoading ? <Spinners setLoading={setLoading} sCustomTop={'120px'} /> :
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label className="fw-semibold"> Бүртгэлийн дугаар </Label>
                      <Input
                        name="groundwater_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.groundwater_code || ""}
                        invalid={
                          validation.touched.groundwater_code &&
                            validation.errors.groundwater_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.groundwater_code &&
                        validation.errors.groundwater_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.groundwater_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Уст үеийн зузаан,м. </Label>
                      <Input
                        name="waterbearing_thickness"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.waterbearing_thickness || ""}
                        invalid={
                          validation.touched.waterbearing_thickness &&
                            validation.errors.waterbearing_thickness
                            ? true
                            : false
                        }
                      />
                      {validation.touched.waterbearing_thickness &&
                        validation.errors.waterbearing_thickness ? (
                        <FormFeedback type="invalid">
                          {validation.errors.waterbearing_thickness}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усны түвшний тооцооны бууралт,м </Label>
                      <Input
                        name="water_level_decrease"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_level_decrease || ""}
                        invalid={
                          validation.touched.water_level_decrease &&
                            validation.errors.water_level_decrease
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_level_decrease &&
                        validation.errors.water_level_decrease ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_level_decrease}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Байршил </Label>
                      <Input
                        name="waterbearing_location"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.waterbearing_location || ""}
                        invalid={
                          validation.touched.waterbearing_location &&
                            validation.errors.waterbearing_location
                            ? true
                            : false
                        }
                      />
                      {validation.touched.waterbearing_location &&
                        validation.errors.waterbearing_location ? (
                        <FormFeedback type="invalid">
                          {validation.errors.waterbearing_location}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хэмжилт хийсэн огноо </Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Огноо"
                        name="measure_date"
                        value={validation.values.measure_date}
                        onChange={(selectDate: Date[]) => {
                          if (selectDate[0]) {
                            const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                              .toISOString()
                              .split('T')[0];
                            validation.setFieldValue('measure_date', localDate);
                          }
                        }}
                        options={{
                          altInput: true,
                          altFormat: "Y-m-d",
                          dateFormat: "Y-m-d",
                          enableTime: false,
                        }}
                      />
                      {validation.touched.measure_date &&
                        validation.errors.measure_date ? (
                        <FormFeedback type="invalid">
                          {validation.errors.measure_date}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усны нөөц баялаг м<sup>3</sup>/хон.</Label>
                      <Input
                        name="water_resource"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_resource || ""}
                        invalid={
                          validation.touched.water_resource &&
                            validation.errors.water_resource
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_resource &&
                        validation.errors.water_resource ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_resource}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Гидрогеологийн цооногийн гүн, м. </Label>
                      <Input
                        name="hydrogeological_borehole_depth"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.hydrogeological_borehole_depth || ""}
                        invalid={
                          validation.touched.hydrogeological_borehole_depth &&
                            validation.errors.hydrogeological_borehole_depth
                            ? true
                            : false
                        }
                      />
                      {validation.touched.hydrogeological_borehole_depth &&
                        validation.errors.hydrogeological_borehole_depth ? (
                        <FormFeedback type="invalid">
                          {validation.errors.hydrogeological_borehole_depth}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усны нөөц баялгийг тооцсон хугацаа, жил </Label>
                      <Input
                        name="water_resource_year"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_resource_year || ""}
                        invalid={
                          validation.touched.water_resource_year &&
                            validation.errors.water_resource_year
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_resource_year &&
                        validation.errors.water_resource_year ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_resource_year}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold">Усны ашиглалтын нөөц баялгийг үнэлсэн цооногийн дугаар </Label>
                      <Input
                        name="waterusage_resource_borehole_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.waterusage_resource_borehole_code || ""}
                        invalid={
                          validation.touched.waterusage_resource_borehole_code &&
                            validation.errors.waterusage_resource_borehole_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.waterusage_resource_borehole_code &&
                        validation.errors.waterusage_resource_borehole_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.waterusage_resource_borehole_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усны нөөц баялгийн зэрэглэл </Label>
                      <Input
                        name="cmd_groundwater_rank"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.cmd_groundwater_rank || ""}
                        invalid={
                          validation.touched.cmd_groundwater_rank &&
                            validation.errors.cmd_groundwater_rank
                            ? true
                            : false
                        }
                      >
                        <option disabled value="">Сонгох</option>
                        {rankData?.data?.map((item, index) => (
                          <option value={item?.id}>{item?.name}</option>
                        ))}
                      </Input>
                      {validation.touched.cmd_groundwater_rank &&
                        validation.errors.cmd_groundwater_rank ? (
                        <FormFeedback type="invalid">
                          {validation.errors.cmd_groundwater_rank}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Цооногийн параметр код </Label>
                      <Input
                        name="groundwater_borehole_parameter_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.groundwater_borehole_parameter_code || ""}
                        invalid={
                          validation.touched.groundwater_borehole_parameter_code &&
                            validation.errors.groundwater_borehole_parameter_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.groundwater_borehole_parameter_code &&
                        validation.errors.groundwater_borehole_parameter_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.groundwater_borehole_parameter_code}
                        </FormFeedback>
                      ) : null}
                    </div>

                  </Col>
                  <Col lg={12} className="d-flex justify-content-around mt-3">
                    <button type="submit" className="btn btn-primary"> Хадгалах </button>
                  </Col>
                </Row>
              </Form>
          }
        </Col>

      </Row>

    </>
  )
}

export default GroundStorage;